import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'
import { ModuleAvailabilityType } from 'modules/core/hooks/useModuleAvailability'
import hasFeature from 'modules/core/lib/hasFeature'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

import { usePayrollBundlePageContext } from 'modules/payroll_bundle/components/PayrollBundle'
import PayrollSummaryWidget from 'modules/payroll_bundle/components/PayrollSummaryWidget'
import { hasInHousePayroll } from 'modules/payroll_bundle/hooks/useInhousePayroll'
import { usePayrollContextlessPolicies } from 'modules/payroll_bundle/hooks/usePayrollContextlessPolicies'

import { FinancialWorkspaceBanner } from './FinancialWorkspaceBanner'
import IncidencesSummary from './IncidencesSummary'
import PaymentSummary from './PaymentSummary'
import RegularCycleSummary from './RegularCycleSummary'
import UpdatesActivation from './UpdateActivation'

const DEFAULT_CURRENCY = 'EUR'

const PolicyPeriodDashboardContent = () => {
  const { selectedPolicy } = usePayrollBundlePageContext()
  const {
    company: { currency: companyCurrency },
  } = useCurrentSession()
  const { canSeeCompanyPayrollResults, canManagePayrollIncidences } =
    usePayrollContextlessPolicies()

  const currency = selectedPolicy?.attributes.currency ?? companyCurrency ?? DEFAULT_CURRENCY

  const canSeeIncidences = (moduleAvailabilities: ModuleAvailabilityType[]) => {
    if (hasFeature('dev_packaging_paywalls')) {
      return (
        isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.payroll) &&
        canManagePayrollIncidences
      )
    }

    return canManagePayrollIncidences
  }

  const { moduleAvailabilities } = useModuleAvailabilities()
  const authorizedToSeeIncidences = canSeeIncidences(moduleAvailabilities)
  const canSeePayrollBundleIncidences =
    (hasFeature('factorial_professionals') || hasInHousePayroll()) && authorizedToSeeIncidences

  return (
    <Box alignSelf="center" width="full">
      <Box gap="s24">
        <FinancialWorkspaceBanner />
        <RegularCycleSummary />
      </Box>
      <Box gap="s32" paddingLeft="s12" paddingRight="s12">
        <Box flexDirection="row" justifyContent="spaceBetween" gap="s32" paddingTop="s32">
          {canSeeCompanyPayrollResults && <PayrollSummaryWidget currency={currency} />}
          {canSeePayrollBundleIncidences && <IncidencesSummary />}
          {!hasFeature('inhouse_payroll') &&
            !hasFeature('factorial_professionals') &&
            authorizedToSeeIncidences && <UpdatesActivation isLoading={false} />}
        </Box>
        {canSeeCompanyPayrollResults && <PaymentSummary currency={currency} />}
      </Box>
    </Box>
  )
}

export default PolicyPeriodDashboardContent
